<template>
  <div :id="`order_${order.id}`" class="z-border-red" style="margin-bottom: 10px">
    <v-layout>
      <v-flex>
        <div class="ma-2">
          <v-checkbox
            :input-value="isCheck"
            :label="`Order No. ${order.id}`"
            style="display: inline-block; margin: 0"
            color="primary"
            hide-details
            @change="assignCb(order.id)"
          ></v-checkbox>
          <span
            v-if="selectedBot.theme == 'runkan' && order.runkanstatus"
            style="position: relative; bottom: 8px"
            ><v-chip
              dark
              small
              dense
              :color="order.runkanstatus == 'SUCCESS' ? 'success' : 'grey'"
              >{{ order.runkanstatus == 'SUCCESS' ? 'วิ่งสำเร็จ' : 'วิ่งไม่สำเร็จ' }}</v-chip
            ></span
          >
        </div>
      </v-flex>
      <v-flex>
        <div class="ma-2 text-xs-right">
          <template v-if="order.app == 'facebook'">
            <em class="fab fa-facebook-square" style="color: #3c5a99" />
          </template>
          <template v-else-if="order.app == 'line'">
            <em class="fab fa-line" style="color: #00c300" />
          </template>
        </div>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex xs12 sm7>
        <div style="border-right: 1px solid #eee; height: 100%">
          <template v-if="typeof orderDetailFormat == 'string'">
            <div class="pa-2">
              <nl2br tag="div" :text="order.productdetail"></nl2br>
            </div>
          </template>
          <template v-else-if="typeof orderDetailFormat == 'object'">
            <template>
              <v-layout wrap>
                <v-flex sm1 xs2>
                  <div class="ma-2">
                    <v-img
                      :src="orderDetailFormat.image"
                      aspect-ratio="1"
                      alt
                      class="grey lighten-2"
                    >
                      <template #placeholder>
                        <v-layout fill-height align-center justify-center ma-0>
                          <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                        </v-layout>
                      </template>
                    </v-img>
                  </div>
                </v-flex>
                <v-flex sm7 xs6 style="word-break: break-word">
                  <div class="ma-2">
                    {{ orderDetailFormat.name
                    }}<!--  x {{ orderDetailFormat.quantity }} -->
                    <template v-if="orderDetailFormat.option"
                      >({{ orderDetailFormat.option }})</template
                    >
                  </div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <!-- <div class="ma-2">฿{{ orderDetailFormat.price | decimalFormat }}</div> -->
                </v-flex>
              </v-layout>
            </template>
          </template>

          <div>
            <v-layout>
              <v-flex>
                <div class="pa-2">{{ $t('คะแนนที่แลกของรางวัล') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">{{ numberFormat(order.amount) }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.shippingcharge != null">
              <v-flex>
                <div class="pa-2">{{ $t('Shipping fee') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">฿{{ order.shippingcharge | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.discount > 0">
              <v-flex>
                <div class="pa-2">{{ $t('Discount') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">-฿{{ order.discount | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>

            <v-layout v-if="jsonValue != null && jsonValue.promocode">
              <v-flex>
                <div class="pa-2">{{ $t('Coupon Code') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">{{ jsonValue.promocode }}</span>
                </div>
              </v-flex>
            </v-layout>

            <v-layout v-if="order.amount != null">
              <v-flex>
                <div class="pa-2">{{ $t('คะแนนคงเหลือ') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">{{
                    numberFormat(parseFloat(order.total) - parseFloat(order.amount))
                  }}</span>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <v-divider />
          <template v-if="!['lookchingiant'].includes(selectedBot.theme)">
            <v-layout>
              <v-flex class="pa-2">
                <img
                  v-if="shippingType == 'normal'"
                  src="/static/img/assets/payment/normal_charge_logo.png"
                  alt
                  class="responsive-img"
                  style="max-height: 50px"
                />
                <img
                  v-else-if="shippingType == 'ems'"
                  src="/static/img/assets/payment/ems_charge_logo.png"
                  alt
                  class="responsive-img"
                  style="max-height: 50px"
                />
                <img
                  v-else-if="shippingType == 'kerry'"
                  src="/static/img/assets/payment/kerry_charge_logo.png"
                  alt
                  class="responsive-img"
                  style="max-height: 50px"
                />
                <template v-else>
                  <template v-if="shippingType">
                    <img
                      :src="'/static/img/assets/payment/' + shippingType + '_logo.png'"
                      alt
                      class="responsive-img"
                      style="max-height: 50px"
                      @error="onImageLoadFailure($event)"
                    />
                    <div v-if="shippingType == 'cod_charge'" class="caption">
                      {{ $t('cod_charge') }}
                    </div>
                  </template>
                </template>
              </v-flex>
              <v-flex class="pa-2 text-xs-right">
                <multiselect
                  v-model="shippingValue"
                  :options="shippingOptions"
                  label="name"
                  select-label
                  selected-label
                  :allow-empty="false"
                  :searchable="false"
                  deselect-label
                  track-by="name"
                  @select="onSelectShipping"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <span class="option__title">
                      <template v-if="props.option.name && props.option.name.includes('other')">{{
                        props.option[4]
                      }}</template>
                      <template v-else>{{ $t(props.option.name) }}</template>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <div>
                      <span class="option__title">
                        <template v-if="props.option.name && props.option.name.includes('other')">{{
                          props.option[4]
                        }}</template>
                        <template v-else>{{ $t(props.option.name) }}</template>
                      </span>
                    </div>
                  </template>
                </multiselect>
              </v-flex>
            </v-layout>
            <v-divider />
          </template>
          <v-layout>
            <v-flex class="pa-2">
              <div>
                สถานะสมาชิก :
                <span :style="order.memberStatus && 'color: #00c500;font-weight: bold'">{{
                  order.memberStatus ? 'Approved' : 'Waiting'
                }}</span>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs12 sm5>
        <div style="word-break: break-word" class="pa-2">
          <a target="_BLANK"> {{ order.first_name }} {{ order.last_name }} </a> (
          {{ nameaddress.name }} )
          <!-- <a target="_BLANK" :href="`https://business.facebook.com${order.inboxurl}`"
            >{{ order.first_name }} {{ order.last_name }}</a
          > -->

          <div style="font-size: 13px">
            <span>{{ nameaddress.address }}</span>
            <span>
              {{ nameaddress.province === 'กรุงเทพมหานคร' ? 'แขวง' : 'ตำบล'
              }}{{ nameaddress.subDistrict }}</span
            >
            <span
              >{{ nameaddress.province === 'กรุงเทพมหานคร' ? 'เขต' : 'อำเภอ'
              }}{{ nameaddress.district }}</span
            >
            <span>จังหวัด{{ nameaddress.province }}</span>
            <span>{{ nameaddress.postCode }}</span>
            <br />
            เบอร์โทรศัพท์ {{ nameaddress.phoneNumber }}
          </div>

          <!-- <template
            v-if="
              selectedBot.pageid == '103012211224246' ||
              selectedBot.pageid == '635426456938760' ||
              selectedBot.pageid == '613259679129221' ||
              selectedBot.pageid == '101857778024677'
            "
          >
            <template v-if="typeof shippingAddressPosition == 'string'">
              <edit-address
                v-model="order.nameaddress"
                :hasCopy="true"
                @edited="$emit('updateOrder', 'save')"
              ></edit-address>
            </template>
            <template v-else>
              <a
                :href="`https://maps.google.com?q=${shippingAddressPosition.lat},${shippingAddressPosition.lng}`"
                target="_blank"
                style="word-break: break-word"
              >
                https://maps.google.com?q={{
                  `${shippingAddressPosition.lat},${shippingAddressPosition.lng}`
                }}
              </a>
            </template>
          </template>
          <template v-else>
            <edit-address
              v-model="order.nameaddress"
              :type="'textarea'"
              @edited="$emit('updateOrder', 'save')"
              :hasCopy="true"
            ></edit-address>
          </template> -->
          <div class="caption mt-3">{{ $t('Status') }}</div>
          <div class="primary--text">{{ order.userstatus ? order.userstatus : '-' }}</div>
          <template v-if="$store.state.centralPage.includes(selectedBot.pageid)">
            <div class="caption mt-3">{{ $t('Live name') }}</div>
            <div class="primary--text">{{ order.livename ? order.livename : '-' }}</div>
          </template>
          <div class="caption mt-3">{{ $t('Tag') }}</div>
          <template v-if="tags.length > 0">
            <v-chip
              v-for="(tag, index) in tags"
              :key="'tag_' + index"
              small
              outline
              color="primary"
              disabled
              >{{ tag }}</v-chip
            >
          </template>
          <template v-else>
            <div class="primary--text">-</div>
          </template>
        </div>
        <v-divider></v-divider>

        <div class="pa-2">
          <template v-if="!(['fbpay'].includes(value.payment) && status.value == 'shipped')">
            <multiselect
              v-model="status"
              :options="orderStatusOptions"
              label="label"
              :allow-empty="false"
              :searchable="false"
              :disabled="status && status.value == 'canceled'"
              select-label
              selected-label
              deselect-label
              track-by="label"
              @select="onSelectOrderStatus"
            ></multiselect>
          </template>
          <template v-else>
            <v-layout>
              <v-flex>
                {{ $t('Order status') }}
              </v-flex>
              <v-flex class="text-xs-right primary--text">
                {{ status.label }}
              </v-flex>
            </v-layout>
          </template>

          <template v-if="order.status == 'shipped'">
            <div class="form-control pt-2">
              <input
                v-model="order.trackingno"
                type="text"
                class="form-control"
                :placeholder="$t('Tracking no.')"
                maxlength="2000"
              />
            </div>
            <div class="form-control pt-2">
              <textarea
                v-model="order.remark"
                type="text"
                class="form-control"
                :placeholder="$t('Remark')"
                maxlength="2000"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                :disabled="
                  order.trackingno == null ||
                  order.trackingno == '' ||
                  order.trackingno.trim() == ''
                "
                @click="$emit('updateOrder', 'send')"
              >
                <em class="far fa-share-square" />
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else-if="order.status == 'canceled'">
            <div class="form-control pt-2">
              <input
                v-model="order.reason"
                type="text"
                class="form-control"
                :placeholder="$t('Reason')"
                maxlength="300"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
                @click="$emit('updateOrder', 'send')"
              >
                <em class="far fa-share-square" />
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else>{{ order.trackingno }}</template>
        </div>
        <v-divider />

        <template v-if="['booking', 'waiting', 'confirm'].includes(order.shippop_status)">
          <div class="pa-2">
            <v-layout>
              <v-flex>สถานะการส่งกับ Shippop</v-flex>
              <v-flex shrink class="text-xs-right">
                <v-chip color="blue" disabled class="white--text" small>
                  {{ order.shippop_status }}
                </v-chip>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex shrink> Shippop Tracking no. </v-flex>
              <v-flex class="text-xs-right">
                <a
                  :href="`https://www.shippop.com/tracking/?tracking_code=${order.shippop_tracking_code}`"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ order.shippop_tracking_code }}
                </a>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex shrink>
                {{ $t('Tracking') }}
              </v-flex>
              <v-flex class="text-xs-right">
                {{ order.trackingno }}
              </v-flex>
            </v-layout>
          </div>
          <v-divider />
        </template>

        <v-layout>
          <v-flex>
            <div class="pa-2">
              <div>
                <template v-if="shippingType && shippingType == 'cod_charge'">
                  {{ $t('cod_charge') }}
                </template>
                <template v-else>
                  <template v-if="order.payment == 'banktransfer' || order.payment == 'transfer'">
                    {{ $t('Bank Transfer') }}
                  </template>
                  <template v-else-if="order.payment == 'cod'">{{ $t('cod_charge') }}</template>
                  <template v-else-if="order.payment == 'qrcode'">Qr Code</template>
                  <template v-else-if="order.payment == 'fbpay'">
                    {{ $t('Mobile Banking') }}
                  </template>
                  <template v-else-if="order.payment == 'credit'">{{ $t('PayPal') }}</template>
                  <template v-else-if="order.payment == 'gbcredit'">{{
                    $t('Credit card')
                  }}</template>
                  <template v-else
                    >{{ order.payment }}
                    <span v-if="order.payment == '2c2p' && order.jsonvalue">
                      {{
                        ': ' +
                        (JSON.parse(order.jsonvalue).payment_channel
                          ? JSON.parse(order.jsonvalue).payment_channel
                          : '-')
                      }}
                    </span>
                  </template>
                </template>
                <div v-if="order.transactionid" class="caption">{{ $t(order.transactionid) }}</div>
              </div>
              {{ order.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
            </div>
          </v-flex>
          <v-flex>
            <div class="pa-2">
              <div style="text-align: right">
                <PrintAllCoversCentral
                  v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  :orders="[order]"
                  :circle="true"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(true, $event)"
                ></PrintAllCoversCentral>
                <print-all-covers
                  v-else
                  :orders="[order]"
                  :circle="true"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(false, $event)"
                ></print-all-covers>
              </div>
            </div>
          </v-flex>
        </v-layout>

        <template v-if="cart_remark">
          <v-divider />
          <div class="pa-2">
            <div
              v-if="
                ['176922345693076', '809510349133469', '103876431747147'].includes(
                  selectedBot.pageid
                )
              "
            >
              ขายโดย
            </div>
            <div class="font-weight-bold primary--text">
              {{ cart_remark }}
            </div>
          </div>
        </template>
      </v-flex>
    </v-layout>
    <template v-if="order.note">
      <div class="hr"></div>
      <a href="javascript:void(0);" style="text-decoration: none" @click="showDetail = !showDetail">
        <div class="text-xs-center" style="margin: 10px auto">
          {{ $t('Click to view slip') }}
          <i class="fas" :class="{ 'fa-chevron-down': showDetail, 'fa-chevron-up': !showDetail }" />
        </div>
      </a>
      <div
        v-show="showDetail"
        style="margin-bottom: 0; background: rgb(253, 253, 253); border-bottom-left-radius: 10px"
      >
        <template v-if="showDetail">
          <template v-if="order.note == 'base64'">
            <load-base64 :key="'slip_' + order.id" :orderid="order.id"></load-base64>
          </template>
          <template v-else-if="order.note">
            <editable
              v-model="order.note"
              :filter="'image'"
              :type="'image'"
              @edited="$emit('updateOrder', 'save')"
            ></editable>
          </template>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './OrderSummaryItem.js'
import LoadBase64 from './LoadBase64'
import EditAddress from './EditAddress'
import api from '@/api'
export default {
  components: {
    'load-base64': LoadBase64,
    EditAddress: EditAddress
  },
  mixins: [mixin],
  computed: {
    orderStatusOptions() {
      var options = [
        // {
        //   label: this.$t('ordered'),
        //   value: 'ordered',
        // },
        {
          label: 'รอดำเนินการ',
          value: 'waiting'
        },
        {
          label: 'รอการจัดส่ง',
          value: 'pending'
        },
        {
          label: 'จัดส่งแล้ว',
          value: 'shipped'
        },
        {
          label: 'ยกเลิกการจัดส่ง',
          value: 'canceled'
        }
      ]

      return options
    },

    nameaddress() {
      var obj = {}
      try {
        obj = JSON.parse(this.order.nameaddress)
      } catch (error) {
        obj = {}
      }

      return obj
    }
  },
  methods: {
    onSelectOrderStatus: async function (status) {
      const vm = this
      const order = this.order
      if (status.value == 'canceled') {
        const response = await this.$swal.fire({
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          showCancelButton: true,
          type: 'warning',
          title: `ยืนยันเปลี่ยนสถานะเป็น "ยกเลิกการจัดส่ง" หรือไม่หากเปลี่ยนแล้ว จะไม่สามารถเปลี่ยนกลับได้อีก`
        })
        if (response && response.dismiss) {
          this.status = this.orderStatusOptions.find(function (element) {
            return element.value == vm.value.status
          })
          return
        }
      }

      order.status = status.value
      this.$emit('input', order)
      this.$emit('onChangeStatus', order)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ToacrmSummaryItem.vue